import { searchableComputedProperty, SB } from '@play-co/replicant';
import { State } from '../State';
import { getPuzzleWinsLast7Days } from '../puzzleWinCount/puzzleWinCount.getters';

export const weeklyLeaderboardProperties = {
  weeklyLeaderboardEntries: searchableComputedProperty(
    SB.array(
      SB.object({
        eventId: SB.string(),
        score: SB.number(),
        joinedAt: SB.number(),
      }),
    ),
    (state: State) => {
      // Return empty array user has not joined any event
      if (!state.weeklyLeaderboard) {
        return [];
      }

      return Object.entries(state.weeklyLeaderboard.entries).map(
        ([eventId, entry]) => ({
          eventId,
          score: entry.score,
          joinedAt: entry.joinedAt,
        }),
      );
    },
  ),

  puzzleWinsLast7Days: searchableComputedProperty(
    SB.int(),
    (state: State, api) => {
      return getPuzzleWinsLast7Days(state, api.date.now()).reduce(
        (acc, cur) => acc + cur,
        0,
      );
    },
  ),
};
